import API from "./index";

const loginAPI = async (username, password) => {
  try {
    const response = await API.post("/login", { username, password });
    const { token, user } = response.data;
    localStorage.setItem("token", token);
    localStorage.setItem("user", JSON.stringify(user));
    return user;
  } catch (error) {
    console.error(error);
  }
};

const registerAPI = async ({ username, password, firstName, lastName }) => {
  try {
    const response = await API.post("/register", {
      username,
      password,
      firstName,
      lastName,
    });

    const { token, user } = response.data;
    localStorage.setItem("token", token);
    localStorage.setItem("user", JSON.stringify(user));
    return user;
  } catch (error) {
    console.error(error);
  }
};

const logoutAPI = async (userId) => {
  try {
    await API.post("/logout", { userId });
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    window.location.href = "/";
  } catch (error) {
    console.error("Logout error:", error);
    // Handle any error that occurred during logout
    // You can display an error message or perform any other action
  }
};

export { loginAPI, registerAPI, logoutAPI };
